import React, { useEffect, useRef } from 'react';
import HotelBookingFlow from '../components/hotels/HotelBookingFlow';
import { decodeSavedOption } from '../utils/hotelBooking';
import { bookingParamReader } from '../utils/bookingContext';

export default function HotelBookingPage() {
  // See FlightBookingPage — the stashed context is consumed on first read, so this is built once.
  const paramsRef = useRef(null);
  if (!paramsRef.current) paramsRef.current = bookingParamReader();
  const params = paramsRef.current;
  const mode = params('mode') === 'quote' ? 'quote' : 'book';

  useEffect(() => {
    document.title = mode === 'quote' ? 'Hotel Option — STX Connect' : 'Hotel Booking — STX Connect';
  }, [mode]);

  const tripId       = params('tripId');
  const sectorIndexRaw = params('sectorIndex', null);
  const sectorIndex  = sectorIndexRaw === null || sectorIndexRaw === '' ? null : Number(sectorIndexRaw);
  const tripType     = params('tripType');
  const clientId     = params('clientId');
  const checkinPre      = params('checkin');
  const checkoutPre     = params('checkout');
  const travellerName   = params('travellerName');
  const destinationCity = params('destinationCity');
  const email           = params('email');
  const savedOption     = decodeSavedOption(params('savedOption'));
  const accessNotes     = params('accessNotes');
  const accessNeeds     = (() => {
    const v = params('accessNeeds', []);
    if (Array.isArray(v)) return v;
    try { const parsed = JSON.parse(v || '[]'); return Array.isArray(parsed) ? parsed : []; }
    catch { return []; }
  })();

  const handleBooked = (bookingData) => {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage({ type: 'HOTEL_BOOKED', tripId, sectorIndex, bookingData }, window.location.origin);
    }
    window.close();
  };

  const handleSaveOption = (optionData) => {
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage({ type: 'HOTEL_OPTION_SAVED', tripId, sectorIndex, optionData }, window.location.origin);
    }
    window.close();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <HotelBookingFlow
        tripId={tripId}
        sectorIndex={sectorIndex}
        tripType={tripType}
        clientId={clientId}
        checkinPre={checkinPre}
        checkoutPre={checkoutPre}
        travellerName={travellerName}
        destinationCity={destinationCity}
        email={email}
        mode={mode}
        savedOption={savedOption}
        accessNeeds={accessNeeds}
        accessNotes={accessNotes}
        onBooked={handleBooked}
        onSaveOption={handleSaveOption}
      />
    </div>
  );
}
